import {
  REACT_BASE_ROUTES,
  getLocale,
  isOtherStoriesBrand,
  isArketBrand,
  isCosBrand,
} from '@pb/utils'

import { demoOrDevPrefix } from 'helpers/demoOrDevPrefix'

const locale = getLocale()
export const CART_ROUTES: any = {
  ...(process.env.IS_REACT_CART_ENABLED && {
    CartOverview: {
      ...REACT_BASE_ROUTES.Cart,
      pathWithLocale: `${demoOrDevPrefix}/${locale}${REACT_BASE_ROUTES.Cart.path}`,
    },
  }),
}

export const PAYMENTS_ROUTES: any = {
  ...(process.env.IS_REACT_PAYMENTS_ENABLED === 'enabled' && {
    PaymentMethods: REACT_BASE_ROUTES.Payments,
    PayPal: { path: `${REACT_BASE_ROUTES.Payments.path}/paypal` },
  }),
}

export const FAVOURITES_ROUTES: any = {
  ...(process.env.IS_REACT_FAVOURITES_ENABLED === 'enabled' && {
    FavouritesOverview: REACT_BASE_ROUTES.Favourites,
  }),
}

export const PUBLIC_PROFILE_ROUTES: any = {
  ...(process.env.IS_PUBLIC_PROFILE_ENABLED === 'enabled' &&
    process.env.IS_STYLEBOARD_ENABLED === 'enabled' && {
      PublicProfileOverview: REACT_BASE_ROUTES.PublicProfile,
    }),
}

export const LINK_ACCOUNT_ROUTES: any = {
  ...(process.env.IS_LINK_ACCOUNT_URL_ENABLED === 'enabled' && {
    LinkAccountsOverview: REACT_BASE_ROUTES.LinkAccounts,
  }),
}

export const STORE_LOCATOR_ROUTES: any = {
  ...(process.env.IS_REACT_STORELOCATOR_ENABLED === 'enabled' && {
    StoreLocatorOverview: REACT_BASE_ROUTES.StoreLocator,
  }),
}

export const DIGITAL_STYLIST_LANDING_ROUTES: any = {
  ...(process.env.IS_REACT_DIGITAL_STYLIST_EDITORIAL_ENABLED === 'enabled' && {
    DigitalStylistOverview: REACT_BASE_ROUTES.DigitalStylistEditorialPage,
  }),
}

export const REGISTER_ROUTES: any = {
  ...(process.env.IS_REACT_REGISTER_ENABLED === 'enabled' && {
    RegisterOverview: REACT_BASE_ROUTES.Register,
  }),
}

export const LOGIN_ROUTES: any = {
  ...(process.env.IS_REACT_LOGIN_ENABLED === 'enabled' && {
    LoginOverview: REACT_BASE_ROUTES.Login,
  }),
  ...(process.env.IS_REACT_LOGIN_CHECKOUT_ENABLED === 'enabled' && {
    LoginCheckout: REACT_BASE_ROUTES.LoginCheckout,
  }),
}

export const RETURNS_ROUTES: any = {
  ...(process.env.IS_DIGITAL_RETURNS_ENABLED === 'enabled' && {
    ReturnsOverview: REACT_BASE_ROUTES.Returns,
    ReturnsItemList: `${REACT_BASE_ROUTES.Returns.path}/order`,
    ReturnsSummary: `${REACT_BASE_ROUTES.Returns.path}/summary/order`,
    ReturnsConfirmation: `${REACT_BASE_ROUTES.Returns.path}/confirm/order`,
  }),
}

export const STYLEBOARD_ROUTES: any = {
  ...(process.env.IS_STYLEBOARD_ENABLED === 'enabled' && {
    Styleboard: REACT_BASE_ROUTES.Styleboard,
    StyleboardLanding: REACT_BASE_ROUTES.StyleboardLanding,
  }),
}

export const STYLESTORY_ROUTES: any = {
  ...(process.env.IS_STYLESTORY_ENABLED === 'enabled' && {
    StyleStories: REACT_BASE_ROUTES.StyleStories,
  }),
}

export const STYLETEST_ROUTES: any = {
  ...(process.env.IS_STYLETEST_ENABLED === 'enabled' && {
    StyleTest: REACT_BASE_ROUTES.StyleTest,
  }),
}

const digitalStylistBasePath = `${REACT_BASE_ROUTES.Account.path}/digital-stylist`
const settingsBasePath = `${REACT_BASE_ROUTES.Account.path}/settings`
const payLaterBasePath = `${REACT_BASE_ROUTES.Account.path}/pay-later`

export const ACCOUNT_ROUTES: any = {
  ...(process.env.IS_REACT_ACCOUNT_ENABLED === 'enabled' && {
    AccountOverview: REACT_BASE_ROUTES.Account,
    HMPay: { path: `${REACT_BASE_ROUTES.Account.path}/hmxklarna` },
    PayLaterStoreActivationInfo: { path: `${payLaterBasePath}/activation-info` },
    PayLaterStoreActivation: { path: `${payLaterBasePath}/activation` },
    Purchases: { path: `${REACT_BASE_ROUTES.Account.path}/purchases` },
    HelpUs: { path: `${REACT_BASE_ROUTES.Account.path}/help-us` },
    AllRewardsList: { path: `${REACT_BASE_ROUTES.Account.path}/all-rewards-list` },

    StoreOrderDetails: { path: `${REACT_BASE_ROUTES.Account.path}/purchases/receipt` },
    OnlineOrderDetails: { path: `${REACT_BASE_ROUTES.Account.path}/purchases/order` },
    Redirect: `${REACT_BASE_ROUTES.Account.path}/redirect`,
    PointsHistory: { path: `${REACT_BASE_ROUTES.Account.path}/points-history` },
    DigitalStylist: { path: digitalStylistBasePath, title: 'digitalstylist.title' },
    QuizLandingPage: {
      path: `${digitalStylistBasePath}/quiz-landing-page`,
      title: 'digitalstylist.quiz.title',
    },
    QuizPage: { path: `${digitalStylistBasePath}/quiz`, title: 'digitalstylist.quiz.title' },
    QuizEndPage: {
      path: `${digitalStylistBasePath}/quiz-end`,
      title: 'digitalstylist.quiz.title',
    },
    QuizResultPage: { path: `${digitalStylistBasePath}/quiz-result` },
    RewardDetail: { path: `${REACT_BASE_ROUTES.Account.path}/rewards` },
    InviteFriend: {
      path: `${REACT_BASE_ROUTES.Account.path}/invite-friend`,
      title: 'invite.a.friend.my.account',
    },
    InviteFriendInfo: { path: `${REACT_BASE_ROUTES.Account.path}/invite-friend/information` },
    Settings: { path: settingsBasePath, title: 'account.my.setting' },
    SettingsEditDigitalReceipts: {
      path: `${settingsBasePath}/my-receipts`,
      title: 'my.settings.print.receipt.title',
    },
    SettingsEditNewsletterSubscription: {
      path: `${settingsBasePath}/my-subscriptions`,
      title: 'account.newsletter.subscribtion.fds',
    },
    SettingsChangePassword: {
      path: `${settingsBasePath}/change-password`,
      title: 'profile.password.change.header',
    },
    SettingsDeleteAccount: {
      path: `${settingsBasePath}/delete-account`,
      title: 'mysettings.manage.account.link.delete',
    },
    SettingsRequestData: {
      path: `${settingsBasePath}/request-data`,
      title: 'myhm.link.download.data',
    },
    SettingsEditPersonalDetails: {
      path: `${settingsBasePath}/personal-details`,
      title: 'text.account.personal.details',
    },
    SettingsCommunitySettings: {
      path: `${settingsBasePath}/community-settings`,
      title: 'text.account.community.settings',
    },
    SettingsAlternativeID: {
      path: `${settingsBasePath}/alternative-member-ids`,
      title: 'text.account.alternative.id',
    },
    SettingsEditAddressBook: {
      path: `${settingsBasePath}/addressbook`,
      title: 'text.account.addressbook.addresses.fds',
    },
    SettingsEditPayments: {
      path: `${settingsBasePath}/payment-details`,
      title: 'account.payment.info.title',
    },
    ChallengesPage: {
      path: `${settingsBasePath}/challenges`,
      title: 'Challenges Page',
    },
  }),
}

const rateAndReviewPath: any = () => {
  let path
  switch (true) {
    case isOtherStoriesBrand:
      path = REACT_BASE_ROUTES.UnreviewedProductsOtherStories.path
      break
    case isArketBrand:
      path = REACT_BASE_ROUTES.UnreviewedProductsArket.path
      break
    case isCosBrand:
      path = REACT_BASE_ROUTES.UnreviewedProductsCos.path
      break
    default:
      path = REACT_BASE_ROUTES.UnreviewedProducts.path
  }
  return path
}

export const RATEANDREVIEWS_ROUTES: any = {
  ...(process.env.IS_ACCOUNT_RATE_AND_REVIEW_PAGE_ENABLED === 'enabled' && {
    UnreviewedProductsPage: {
      path: rateAndReviewPath(),
      title: 'profile.unreviewedproducts.review.page.reviews',
    },
  }),
}

export const CHECKOUT_ROUTES = {
  CheckoutOverview: {
    ...REACT_BASE_ROUTES.Checkout,
    pathWithLocale: `${demoOrDevPrefix}/${locale}${REACT_BASE_ROUTES.Checkout.path}`,
  },
}

export const REACT_ROUTES = {
  ...ACCOUNT_ROUTES,
  ...CHECKOUT_ROUTES,
  ...CART_ROUTES,
  ...PAYMENTS_ROUTES,
  ...FAVOURITES_ROUTES,
  ...STORE_LOCATOR_ROUTES,
  ...REGISTER_ROUTES,
  ...LOGIN_ROUTES,
  ...DIGITAL_STYLIST_LANDING_ROUTES,
  ...STYLEBOARD_ROUTES,
  ...STYLESTORY_ROUTES,
  ...STYLETEST_ROUTES,
  ...RETURNS_ROUTES,
  ...LINK_ACCOUNT_ROUTES,
  ...RATEANDREVIEWS_ROUTES,
  ...PUBLIC_PROFILE_ROUTES,
}
